module.exports = __webpack_public_path__ + "img/card.c0b9923b.jpg";